import { Suspense } from 'react';
import { useLoaderData, json, defer, Await, useRouteLoaderData } from 'react-router-dom';

import Vendor from '../components/Vendor.jsx';
import VendorList from '../components/VendorList.jsx';
import { loadServices } from '../pages/Services.jsx';

import classes from '../components/VendorList.module.css';

import backend from '../util/backend.jsx';

function VendorsPage() {
  const { vendors } = useLoaderData();

  return (
    <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
      <Await resolve={vendors}>
        {(loadedVendors) => <VendorList vendors={loadedVendors} />}
      </Await>
    </Suspense>
  );

}


function VendorVendorsPage() {
  const { vendor, vendors } = useRouteLoaderData('vendors-vendor');

  return (
    <>
      <div className={classes.vendorvendors}>
      <table className={classes.vendorlist}>
      <tr>
      <td>
      <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
        <Await resolve={vendors}>
          {(loadedVendors) => <VendorList vendors={loadedVendors} />}
        </Await>
      </Suspense>
      </td>
      <td>
      <div className={classes.divider}>
      </div>
      </td>
      <td>
      <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
        <Await resolve={vendor}>
          {(loadedVendor) => <Vendor vendor={loadedVendor} />}
        </Await>
      </Suspense>
      </td>
      </tr>
      </table>
      </div>
    </>
  );
}

export {VendorsPage, VendorVendorsPage};

let loadedVendorData = [];
let loadedVendorDict = {};

async function loadVendors() {
  const response = await fetch(`https://${backend}/vendors`);

  if (!response.ok) {
    throw json(
      { message: 'Could not fetch vendors.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    //console.log(`vendors: ${resData}`);
    loadedVendorData = resData;
    for (let index = 0; index < loadedVendorData.length; index++) {
      loadedVendorDict[loadedVendorData[index].id] = loadedVendorData[index];
      //console.log(`Vendor id: ${loadedVendorData[index].id} data: ${JSON.stringify(loadedVendorData[index])}`);
    }
    return resData;
  }
}

export function loader() {
  return defer({
    vendors: loadVendors(),
  });
}

async function loadVendor(id) {
  console.log(`loadVendor id: ${id}`);
  return loadedVendorDict[id];
}

export async function vendorVendorsLoader({ request, params }) {
  const id = params.vendorId;

  return defer({
    vendors: loadVendors(),
    vendor: loadVendor(id),
    services: loadServices(id),
  });
}
